/*
 *   File : systematic-plans.js
 *   Author : https://evoqins.com
 *   Description : Customer Systematics Plan tab (SIP / SWP / STP)
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { CustomTab } from '../../../Components/Others';
import { SWP, STP } from '../../SystematicPlan';
import AllSips from './all-sip';

const PLAN_TABS = [
    { id: 1, label: 'SIP' },
    { id: 2, label: 'SWP' },
    { id: 3, label: 'STP' },
];

const SystematicPlans = () => {
    const { state } = useLocation();
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.systematic_plan_tab || 1);

    useEffect(() => {
        if (state?.systematic_plan_tab) {
            setSelectedTab(state.systematic_plan_tab);
        }
    }, [state?.systematic_plan_tab]);

    const _handleTab = (tab_id) => {
        setSelectedTab(tab_id);
        navigate(location.pathname.includes("support") ? `/support/${id}` : `/customers/${id}`, {
            state: {
                ...state,
                inner_tab_index: state?.inner_tab_index || 4,
                systematic_plan_tab: tab_id,
            }
        });
    };

    return (
        <div>
            <div className='d-flex padding-32px-lr padding-32px-top'>
                <CustomTab data={PLAN_TABS}
                    selectedTab={selectedTab}
                    tooltip={false}
                    handleClick={_handleTab} />
            </div>

            {selectedTab === 1 &&
                <AllSips />
            }

            {selectedTab === 2 &&
                <SWP customerId={id} embedded />
            }

            {selectedTab === 3 &&
                <STP customerId={id} embedded />
            }
        </div>
    );
};

export default SystematicPlans;
